import { Component, OnInit } from '@angular/core';
import { SrubUpService } from '../Services/ScrubUp.service';
import { CookieService } from 'ngx-cookie-service';
import { AppWideUser, Token } from '../Services/AppUserProfile';
@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.scss'],
  providers: [SrubUpService],
})
export class StatisticsComponent implements OnInit {
  loginUserId: number;
  totalJournals='';
  totalShifts='';
  totalProffLearn='';
  totalActiveSubscribers='';
  totalFreemium='';
  totalTier1Monthly='';
  totalTier1Annually='';
  totalTier2Monthly='';
  totalTier2Annually='';
  statisticsData:any=[];
  public loading = false;
  constructor( private scrubUpService: SrubUpService,private cookieService: CookieService, private appUser: AppWideUser, private token: Token) {
if (this.appUser.UserName == undefined && this.token.access_token == undefined || this.appUser.UserName == null && this.token.access_token == null) {

      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
            this.appUser = JSON.parse(this.cookieService.get('AppWideUser'));
            this.token = JSON.parse(this.cookieService.get('Token'));
        }
         this.loginUserId = this.appUser.UserId;
  }

  ngOnInit() {
    this.getStatistics();
  }
  getStatistics()
  {
    this.loading = true;
    this.scrubUpService.getStatisticsReport(this.token).subscribe(x => {
      if (x['Data'] != null && x['Status'] == true) {
        this.statisticsData = x['Data'];
        this.totalJournals = this.statisticsData.TotalJournals;
        this.totalShifts = this.statisticsData.TotalShifts;
        this.totalProffLearn = this.statisticsData.TotalProfessionalLearningData;
        this.totalActiveSubscribers = this.statisticsData.TotalActiveSubscribers;
        this.totalFreemium = this.statisticsData.TotalActiveFreemium;
        this.totalTier1Monthly = this.statisticsData.TotalActiveTier1Monthly;
        this.totalTier1Annually = this.statisticsData.TotalActiveTier1Annually;
        this.totalTier2Monthly = this.statisticsData.TotalActiveTier2Monthly;
        this.totalTier2Annually = this.statisticsData.TotalActiveTier2Annually;
      }
      this.loading = false;

    },
      error => {
        this.loading = false;
      })
  }
}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/statistics/statistics.component.ts